/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { BANK_ACCOUNT_STATUS_LABELS } from '../constants';

// Situação da conta bancária: ativa (verde) × inativa (neutro). Inativa não é
// erro — é uma conta que existe mas não opera; por isso neutro, não vermelho.
export default function BankAccountStatusBadge({ value }) {
   const label = BANK_ACCOUNT_STATUS_LABELS[value] ?? value ?? '—';
   return (
      <StatusBadge variant={value === 'active' ? 'green' : 'neutral'}>
         {label}
      </StatusBadge>
   );
}

BankAccountStatusBadge.propTypes = {
   value: PropTypes.string,
};
